<template>
  <div class="timeline-item">
    <v-menu
      max-height="300px"
      :close-on-content-click="false"
      offset-x
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-flex
          class="timeline-item__container flex-fill"
        >
          <v-row
            class="timeline-item__text top flex-fill ma-0 text-truncate "
          >
            <span
              class="caption timeline-item__name"
            >
              {{processing["dh_created"] | dateDisplay}}
            </span>
          </v-row>
          <v-btn
            v-on="on"
            fab
            x-small
            :color="isActive ? 'accent' : 'primary'"
            :disabled="isDisabled"
            :class="isActive ? 'spin-globe' : ''"
          >
            <v-icon v-text="$vuetify.icons.values['mdiEarth']"/>
          </v-btn>
          <v-flex
            :class="['orbit-drone__wrapper', {
              'spin-drone': isActive
            }]"
          >
            <component
              :is="droneIcon"
              :class="['orbit-drone', {
              'active': isActive,
              'disabled': isDisabled
            }]"
            />
          </v-flex>
          <v-row
            class="timeline-item__text bottom flex-fill ma-0 text-truncate "
          >
            <span
              class="caption timeline-item__name"
              v-text="processing['nm_processing']"
            />
          </v-row>
        </v-flex>
      </template>
      <processing-timeline-item-results
        :processing="processing"
      />
    </v-menu>
  </div>
</template>

<script>
  import ProcessingTimelineItemResults from "./ProcessingTimelineItemResults"
  import {find} from "lodash/collection"
  import {gte, isEqual} from "lodash/lang"
  import moment from "moment"

  const _Map = Symbol.for("_Map")

  export default {
    name: "ProcessingsTimelineItem",
    components: {ProcessingTimelineItemResults},
    inject: {_Map},
    props: {
      processing: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        layer: null,
      }
    },
    filters: {
      dateDisplay(value) {
        return moment(value).format("DD/MM/YYYY")
      }
    },
    computed: {
      Map() {
        return this._Map()
      },
      isActive() {
        if (!this.Map) return false
        return Boolean(find(
          this.Map.sideBySide.idleLayers,
          item => isEqual(item["processing"]["id_processing"], this.processing["id_processing"])
        ))
      },
      isDisabled() {
        if (!this.Map) return true
        return gte(this.Map.sideBySide.idleLayers.length, 2) &&
          Boolean(!find(
            this.Map.sideBySide.idleLayers,
            item => isEqual(item["processing"]["id_processing"], this.processing["id_processing"])
          ))
      },
      droneIcon() {
        const SVGIcon = require("../../../assets/icons/drone-icon.svg?inline")
        return SVGIcon.default
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "src/sass/helpers";

  .timeline-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .timeline-item__container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .timeline-item__text {
    position: absolute;
    text-align: center;
    height: auto;
    padding: 10px;
    white-space: nowrap;
    display: inline-block;
    color: white;
    width: 132px;
    text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.1s ease-out;

    &.top {
      bottom: 100%;
    }

    &.bottom {
      top: 100%;
    }
  }

  .spin-globe {
    -webkit-animation: spin 4s infinite linear;
    animation: spin 4s infinite linear;
  }

  .spin-drone {
    -webkit-animation: spin 8s infinite linear;
    animation: spin 8s infinite linear;
  }

  .orbit-drone__wrapper {
    position: absolute;
    justify-content: center;
    width: 32px;
    height: 32px;
    transition: .4s cubic-bezier(.4, 0, .2, 1);
    transition-property: all;
    transition-duration: 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0s;
    -webkit-transition: all 1s;
  }

  .orbit-drone {
    stroke: var(--v-secondary-base);
    fill: var(--v-primary-base);
    position: static;
    display: flex;
    z-index: 999999999;
    transform: translateY(-60%);
    transition: .4s cubic-bezier(.4, 0, .2, 1);
    transition-property: all;
    transition-duration: 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0s;
    -webkit-transition: all 1s;

    &.active {
      fill: var(--v-accent-base);
    }

    &.disabled {
      fill: none;
    }
  }

  .v-btn {
    z-index: 4;
  }

  .v-icon {
    width: 28px !important;
    height: 28px !important;
    font-size: 28px !important;
  }

</style>
